module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/170-greece-b2fe445165d0a59186dd686482503460.svg";